module.exports = __webpack_public_path__ + "static/media/active-patients.77891ea9.svg";